import { StoreState } from 'state/types';

const getState = (state: StoreState) => state.paymentAssignedUsersDialog;

export const getPaymentAssignedUserIds = (state: StoreState) =>
  getState(state).user_ids;
